import { render, staticRenderFns } from "./ContactWay.vue?vue&type=template&id=5b28e336&scoped=true&"
import script from "./ContactWay.vue?vue&type=script&lang=js&"
export * from "./ContactWay.vue?vue&type=script&lang=js&"
import style0 from "./ContactWay.vue?vue&type=style&index=0&id=5b28e336&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b28e336",
  null
  
)

export default component.exports